import { styled } from '@mui/material/styles'; 
import Drawer from '@mui/material/Drawer';
import { 
    Button,
    Card,
    TextM,
    WhiteSpace
 } from '../components';
import { useEthers } from '../ethers';
import {
    SwitchChain,
    ShortAddress
} from '../ethers/e'
import { useTranslation } from 'react-i18next';

// WalletConnect.tsx
import { useAccount, useConnect, useDisconnect, useSwitchChain } from "wagmi";
import { useState } from 'react';

const _wList = {
    MetaMask: {
        src: '/wallet/metamask.webp'
    },
    trust: {
        src: '/wallet/trust.webp'
    },
    'OKX Wallet': {
        src: '/wallet/ok.webp'
    },
    ImToken: {
        src: '/wallet/imtoken.webp'
    },
    TokenPocket: {
        src: '/wallet/tp.webp'
    },
    'Binance Wallet': {
        src: '/wallet/bnb.webp'
    },
    // Injected: {
    //     src: '/wallet/other.webp'
    // }
}

// wallet button
export function WalletButton() {
    return <WalletSelector />
}


function WalletSelector({buttonType}) {
    const account = useAccount()
    const { connectors, connect } = useConnect();
    const { disconnect } = useDisconnect();
    const [openWallet, setOpen] = useState(false)
    const open = () => setOpen(true)
    const close = () => setOpen(false)
    const {t} = useTranslation()
    const { switchChain } = useSwitchChain()
    // connectors.map(v => {
    //     console.log(v.name)
    // })
    return (
        <>
            <Button
                onClick={open}
                {...buttonType}
            >{account.address ? ShortAddress(account.address) : t('Connect')}</Button>
            <Drawer
                open={openWallet}
                onClose={close}
                anchor='top'
            >
                <Card
                    sx={{
                        padding: '18px'
                    }}
                >
                    <TextM>{t('My Wallet')}</TextM>
                    <WhiteSpace />
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <WalletRow>
                            {   
                                connectors.map(v => (
                                    _wList[v.name]?.src &&
                                    <WalletWrap
                                        key={v.name}
                                        onClick={() => {
                                            if (v.name !== 'Binance Wallet') switchChain({chainId: 56})
                                            connect({ connector:v })
                                            close()
                                        }}
                                    >
                                        <WalletLogo src={_wList[v.name]?.src || _wList.other.src}/>
                                    </WalletWrap>
                                ))
                            }
                        </WalletRow>
                        <WalletWrap
                            onClick={() => {
                                // console.log(v)
                                // connect({ connector:v })
                                disconnect()
                                close()
                                
                            }}
                        >
                            <WalletLogo src='/wallet/off.png'/>
                        </WalletWrap>
                    </div>
                    
                </Card>
            </Drawer>
        </>
    )
}

const WalletLogo = styled('img')`
    width: 45px;
    height: 45px;
    display: block;
    border-radius: 16px;
`
const WalletWrap = styled('div')`
    padding: 8px;
    width: min-content;
    background: #1d1e2273;
    text-align: center;
    border-radius: 12px;
    margin: 0px 8px 0px 0px;
`
const WalletRow = styled('div')`
    display: flex;
`

// add chain button
/**
 * @param {Object} chainInfo
 * @param {string} chainInfo.name
 * @param {string} chainInfo.chainId hex
 * @param {string} chainInfo.rpcUrl
 * @param {string} chainInfo.blockExplorerUrls
 * @param {string} chainInfo.nativeCurrency.name
 * @param {string} chainInfo.nativeCurrency.symbol
 * @param {number} chainInfo.nativeCurrency.decimals
 */
export function AddChainButton({ children, chainInfo={}, ...props }) {
    const addNet = () => {
        SwitchChain(chainInfo)
    }
    return (
        <Button
            {...props}
            onClick={addNet}
        >
            {children}
        </Button>
    )
}

